import React, { useEffect, useRef, useState } from 'react';

const NetworkAnimation = () => {
  const containerRef = useRef(null);
  const [nodes, setNodes] = useState([]);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    // Generate random nodes
    const generateNodes = () => {
      const newNodes = [];
      for (let i = 0; i < 20; i++) {
        newNodes.push({
          id: i,
          x: Math.random() * 100,
          y: Math.random() * 100,
          size: 4 + Math.random() * 4,
          speed: 0.5 + Math.random() * 1,
          direction: Math.random() * Math.PI * 2
        });
      }
      setNodes(newNodes);
    };
    generateNodes();
  }, []);

  const handleMouseMove = (e) => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      setMousePos({
        x: ((e.clientX - rect.left) / rect.width) * 100,
        y: ((e.clientY - rect.top) / rect.height) * 100
      });
    }
  };

  const getDistance = (x1, y1, x2, y2) => {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
  };

  return (
    <div
      ref={containerRef}
      className="absolute inset-0 overflow-hidden"
      onMouseMove={handleMouseMove}
    >
      <svg className="w-full h-full" preserveAspectRatio="none">
        {/* Connection lines */}
        {nodes.map((node, i) =>
          nodes.slice(i + 1).map((otherNode, j) => {
            const distance = getDistance(node.x, node.y, otherNode.x, otherNode.y);
            if (distance < 25) {
              return (
                <line
                  key={`${i}-${j}`}
                  x1={`${node.x}%`}
                  y1={`${node.y}%`}
                  x2={`${otherNode.x}%`}
                  y2={`${otherNode.y}%`}
                  stroke="#06b6d4"
                  strokeWidth="1"
                  opacity={1 - distance / 25}
                  className="transition-opacity duration-300"
                />
              );
            }
            return null;
          })
        )}

        {/* Mouse connection lines */}
        {nodes.map((node, i) => {
          const distance = getDistance(node.x, node.y, mousePos.x, mousePos.y);
          if (distance < 20) {
            return (
              <line
                key={`mouse-${i}`}
                x1={`${node.x}%`}
                y1={`${node.y}%`}
                x2={`${mousePos.x}%`}
                y2={`${mousePos.y}%`}
                stroke="#14b8a6"
                strokeWidth="1.5"
                opacity={1 - distance / 20}
              />
            );
          }
          return null;
        })}

        {/* Nodes */}
        {nodes.map((node) => (
          <g key={node.id}>
            <circle
              cx={`${node.x}%`}
              cy={`${node.y}%`}
              r={node.size}
              fill="#0f172a"
              stroke="#06b6d4"
              strokeWidth="1.5"
              className="animate-pulse-slow"
              style={{ animationDelay: `${node.id * 0.1}s` }}
            />
            <circle
              cx={`${node.x}%`}
              cy={`${node.y}%`}
              r={node.size * 0.4}
              fill="#06b6d4"
              className="animate-pulse"
              style={{ animationDelay: `${node.id * 0.15}s` }}
            />
          </g>
        ))}

        {/* Mouse indicator */}
        <circle
          cx={`${mousePos.x}%`}
          cy={`${mousePos.y}%`}
          r="8"
          fill="none"
          stroke="#14b8a6"
          strokeWidth="2"
          opacity="0.5"
          className="transition-all duration-100"
        />
      </svg>
    </div>
  );
};

export default NetworkAnimation;
